
  import { Checklist as HomepageChecklist } from '@/entities/homepage';
  import { listChecklists } from '@/services/api/resources/homepage';
  import { startNewInspection } from '@/services/inspections/inspectionsService';
  import Widget, { CollapsibleProperties } from '@/ui/components/home/Widget.vue';
  import StaticPagination from '@/ui/components/StaticPagination.vue';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { useTask } from '@/ui/concerns';
  import { startInspection } from '@/ui/pages/checklist/StartInspection';
  import { router } from '@/ui/routes';
  import { defineComponent, ref, watch } from 'vue';
  import { Loader } from '@/ui/components/Loader';

  const YOUR_TEMPLATES_COUNT = 5;

  export default defineComponent<CollapsibleProperties>({
    components: {
      Widget,
      Loader,
      ResourceTable,
      Pagination: StaticPagination,
      StartInspection: {
        functional: true,
        render(_: never, { props: { checklist } }: { props: { checklist: HomepageChecklist } }) {
          return startInspection(checklist, true);
        },
      },
    },
    props: ['collapsible'],
    setup() {
      const templates = ref<HomepageChecklist[]>([]);
      const page = ref(1);
      const total = ref(0);
      const isEmpty = ref(false);

      const getHomepageChecklistsTask = useTask(
        () => listChecklists({ page: page.value, perPage: YOUR_TEMPLATES_COUNT }),
        response => {
          templates.value = response.data;
          total.value = response.meta.total;
          isEmpty.value = templates.value.length === 0;
        },
      );

      const onPageChanged = (value: number) => {
        page.value = value;
      };

      watch([page], () => getHomepageChecklistsTask.run({ page: page.value }));

      const goToUpdate = (checklistId: number) => {
        router.push({
          name: 'checklistEdit',
          params: { id: checklistId.toString() },
        });
      };

      const clickOnChecklist = (checklist: HomepageChecklist, e: MouseEvent) => {
        if (checklist.authorizedTo.update) {
          goToUpdate(checklist.id);
          return;
        }

        startNewInspection(checklist.id, e);
      };

      const showConductButton = (checklist: HomepageChecklist) => {
        return checklist.authorizedTo.conduct;
      };

      return {
        getHomepageChecklistsTask,
        templates,
        clickOnChecklist,
        page,
        perPage: YOUR_TEMPLATES_COUNT,
        total,
        onPageChanged,
        showConductButton,
        isEmpty,
      };
    },
  });
